import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./breadcrumb.css";

const routeLabels = {
  "internship-proposals": "Internship Proposals",
  "challenges-opportunities": "Challenges & Opportunities",
  "registered-internships": "Registered Internships",
  "tenders": "Tenders",
  "publications": "Publications",
  "company-users": "Company Users",
  "vendors": "Vendors",
  "resource-personnel": "Resource Personnel",
  "expert-manpower": "Expert Manpower",
  "projects": "Projects",
  "messages": "Messages",
  "advisors": "Advisors",
  "news": "News",
  "policies": "Policies",
  "history": "History"
};

class BreadCrumpBack extends Component {
  render() {
    const { location } = this.props;
    const pathname = location?.pathname || window.location.pathname;
    
    // Split the pathname to construct breadcrumbs
    const pathParts = pathname.split("/").filter(Boolean);
    
    const breadcrumbs = [
      { path: "/", label: "Home", isLast: pathParts.length === 0 }
    ];
    
    let currentPath = "";
    pathParts.forEach((part, index) => {
      currentPath += `/${part}`;
      const isLast = index === pathParts.length - 1;
      
      // If the part is a numeric ID, we can display "Details" or "View"
      let label = part;
      if (/^\d+$/.test(part)) {
        label = "Details";
      } else {
        // Look up pretty label, or clean up the string (hyphens to spaces, capitalize)
        const matchedLabel = routeLabels[part];
        if (matchedLabel) {
          label = matchedLabel;
        } else {
          label = part
            .split("-")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
        }
      }
      
      breadcrumbs.push({
        path: currentPath,
        label,
        isLast
      });
    });

    return (
      <div className="breadcrumb-wrapper2-full">
        <div className="container-fluid px-0">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-modern mb-0">
              {breadcrumbs.map((bc, idx) => {
                if (bc.isLast) {
                  return (
                    <li key={idx} className="breadcrumb-item-modern active" aria-current="page">
                      <span>{bc.label}</span>
                    </li>
                  );
                }
                return (
                  <li key={idx} className="breadcrumb-item-modern">
                    <Link to={bc.path}>
                      {idx === 0 && <i className="fa fa-home mr-1" style={{ color: "#64748b" }}></i>}
                      {bc.label}
                    </Link>
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      </div>
    );
  }
}

export default withRouter(BreadCrumpBack);
